import { render, staticRenderFns } from "./CompArticlesStats.vue?vue&type=template&id=7162960c"
import script from "./CompArticlesStats.vue?vue&type=script&setup=true&lang=js"
export * from "./CompArticlesStats.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports